<div class="kt-portlet">
	<div class="kt-portlet__head kt-portlet__head__custom">
		<div class="kt-portlet__head-label">
			<h3 class="kt-portlet__head-title">{{data.title}}</h3>
			<span class="kt-portlet__head-icon kt-hide">
				<i class="la la-gear"></i>
			</span>
		</div>
	</div>
	<div class="kt-form">
		<div class="kt-portlet__body">
			<div class="form-group kt-form__group row">
				<div class="col-lg-12" style="white-space:pre-line">
					{{data.description}}
				</div>
			</div>
		</div>
		<div class="kt-portlet__foot kt-portlet__no-border kt-portlet__foot--fit text-right">
			<div class="kt-form__actions kt-form__actions--sm">
				<div fxLayout="row" fxLayout.lt-md="column" fxFlex fxLayoutGap="0px" style="margin-top:10px">
					<div fxFlex align="right">
						<button mat-raised-button class="copy-icon-button" *ngIf="data.showCopyIconButton"
							[matTooltip]="'Copy' | translate"
							(click)="onYesClick()" style="margin: 2px 4px 2px 0;">
							<mat-icon>content_copy</mat-icon>
						</button>
						<button class="green-text" mat-raised-button (click)="onYesClick()" *ngIf="data.confirmbtn"
							cdkFocusInitial>{{data.confirmbtn}}</button>&nbsp;
						<button class="red-text" mat-raised-button (click)="onNoClick()"
							*ngIf="data.cancelbtn">{{data.cancelbtn}}</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>